<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img class="navbar-brand-full mr-3" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
      <!-- <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo"> -->
    </template>
    <template slot="dropdown">
      <b-card no-body style="width:560px;border:0;margin-bottom:0;">
        <b-row>
          <b-col class="col-4 pr-1">
            <coreui-menu-items :menu="devloperMenus[0]" />
            <coreui-menu-items :menu="devloperMenus[1]" />
            <coreui-menu-items :menu="devloperMenus[2]" />
          </b-col>
          <b-col class="col-4 px-1">
            <coreui-menu-items :menu="devloperMenus[3]" />
            <coreui-menu-items :menu="devloperMenus[4]" />
            <coreui-menu-items :menu="devloperMenus[5]" />
            <coreui-menu-items :menu="devloperMenus[6]" />
            <coreui-menu-items :menu="devloperMenus[7]" />
          </b-col>
          <b-col class="col-4 pl-1">
            <coreui-menu-items :menu="devloperMenus[8]" />
            <coreui-menu-items :menu="devloperMenus[9]" />
            <coreui-menu-items :menu="devloperMenus[10]" />
            <coreui-menu-items :menu="devloperMenus[11]" />
          </b-col>
        </b-row>
      </b-card>

<!--
      <template v-for="(menu1, index) in devloperMenus">
        <div :key="index">
          <template v-if="menu1.title === true || (menu1.children && menu1.children.length > 0)">
            <b-dropdown-header tag="div" class="dropdown-menu-lg text-center"><strong>{{ menu1.name }}</strong></b-dropdown-header>
            <template v-for="(menu2, subidx) in menu1.children" v-if="(menu1.children && menu1.children.length > 0)">
              <b-dropdown-item :key="index + '_' + subidx" :to="menu2.url" class="coreui-link"><i :class="menu2.icon"></i> {{ menu2.name }}</b-dropdown-item>
            </template>
          </template>
          <template v-else>
              <b-dropdown-item :to="menu1.url" class="coreui-link"><i :class="menu1.icon"></i> {{ menu1.name }}</b-dropdown-item>
          </template>
        </div>
      </template>
-->
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import Vue from 'vue'

Vue.component('coreui-menu-items', {
  props: ['menu'],
  template: `
            <div>
              <template v-if="(menu.children && menu.children.length > 0)">
                <b-dropdown-header tag="div" class="text-center"><strong>{{ menu.name }}</strong></b-dropdown-header>
                <template v-for="(menu2, subidx) in menu.children" v-if="(menu.children && menu.children.length > 0)">
                  <b-dropdown-item :key="subidx" :to="menu2.url" class="coreui-link"><i :class="menu2.icon"></i> {{ menu2.name }}</b-dropdown-item>
                </template>
              </template>
              <template v-else>
                  <b-dropdown-item :to="menu.url" class="coreui-link"><i :class="menu.icon"></i> {{ menu.name }}</b-dropdown-item>
              </template>
            </div>
  `
});
/*

*/

export default {
  name: 'DefaultHeaderDropdownCoreUI',
  components: {
    AppHeaderDropdown
  },
  data () {
    return {
      itemsCount: 5,
      devloperMenus: [
        // {
        //     title: true,
        //     name: 'Developer',
        //     url: '/coreui/coreui/',
        //     icon: 'icon-people',
        // },
        {
          name: 'Theme',
          url: '/coreui/coreui/theme',
          icon: 'icon-puzzle',
          children: [
            {
              name: 'Colors',
              url: '/coreui/coreui/theme/colors',
              icon: 'icon-drop'
            },
            {
              name: 'Typography',
              url: '/coreui/coreui/theme/typography',
              icon: 'icon-pencil'
            }
          ]
        },
        {
          name: 'Base',
          url: '/coreui/coreui/base',
          icon: 'icon-puzzle',
          children: [
            {
              name: 'Breadcrumbs',
              url: '/coreui/coreui/base/breadcrumbs',
              icon: 'icon-puzzle'
            },
            {
              name: 'Cards',
              url: '/coreui/coreui/base/cards',
              icon: 'icon-puzzle'
            },
            {
              name: 'Carousels',
              url: '/coreui/coreui/base/carousels',
              icon: 'icon-puzzle'
            },
            {
              name: 'Collapses',
              url: '/coreui/coreui/base/collapses',
              icon: 'icon-puzzle'
            },
            {
              name: 'Jumbotrons',
              url: '/coreui/coreui/base/jumbotrons',
              icon: 'icon-puzzle'
            },
            {
              name: 'List Groups',
              url: '/coreui/coreui/base/list-groups',
              icon: 'icon-puzzle'
            },
            {
              name: 'Navs',
              url: '/coreui/coreui/base/navs',
              icon: 'icon-puzzle'
            },
            {
              name: 'Navbars',
              url: '/coreui/coreui/base/navbars',
              icon: 'icon-puzzle'
            },
            {
              name: 'Paginations',
              url: '/coreui/coreui/base/paginations',
              icon: 'icon-puzzle'
            },
            {
              name: 'Popovers',
              url: '/coreui/coreui/base/popovers',
              icon: 'icon-puzzle'
            },
            {
              name: 'Progress Bars',
              url: '/coreui/coreui/base/progress-bars',
              icon: 'icon-puzzle'
            },
            {
              name: 'Switches',
              url: '/coreui/coreui/base/switches',
              icon: 'icon-puzzle'
            },
            {
              name: 'Tabs',
              url: '/coreui/coreui/base/tabs',
              icon: 'icon-puzzle'
            },
            {
              name: 'Tooltips',
              url: '/coreui/coreui/base/tooltips',
              icon: 'icon-puzzle'
            }
          ]
        },
        {
          name: 'Buttons',
          url: '/coreui/coreui/buttons',
          icon: 'icon-cursor',
          children: [
            {
              name: 'Buttons',
              url: '/coreui/coreui/buttons/standard-buttons',
              icon: 'icon-cursor'
            },
            {
              name: 'Brand Buttons',
              url: '/coreui/coreui/buttons/brand-buttons',
              icon: 'icon-cursor'
            },
            {
              name: 'Button Dropdowns',
              url: '/coreui/coreui/buttons/dropdowns',
              icon: 'icon-cursor'
            },
            {
              name: 'Button Groups',
              url: '/coreui/coreui/buttons/button-groups',
              icon: 'icon-cursor'
            }
          ]
        },
        {
          name: 'Editors',
          url: '/coreui/coreui/editors',
          icon: 'fa fa-code',
          children: [
            {
              name: 'Code Editors',
              url: '/coreui/coreui/editors/code-editors',
              icon: 'fa fa-code',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            },
            {
              name: 'Text Editors',
              url: '/coreui/coreui/editors/text-editors',
              icon: 'icon-note',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            }
          ]
        },
        {
          name: 'Forms',
          url: '/coreui/coreui/forms',
          icon: 'icon-note',
          children: [
            {
              name: 'Basic Forms',
              url: '/coreui/coreui/forms/basic-forms',
              icon: 'icon-note'
            },
            {
              name: 'Advanced Forms',
              url: '/coreui/coreui/forms/advanced-forms',
              icon: 'icon-note',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            },
            {
              name: 'Validation',
              url: '/coreui/coreui/forms/validation-forms',
              icon: 'icon-note',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            },
            {
              name: 'Form Input Array',
              url: '/coreui/coreui/forms/input-array-forms',
              icon: 'icon-note',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            }
          ]
        },
        {
          name: 'Icons',
          url: '/coreui/coreui/icons',
          icon: 'icon-star',
          children: [
            {
              name: 'CoreUI Icons',
              url: '/coreui/coreui/icons/coreui-icons',
              icon: 'icon-star',
              badge: {
                variant: 'info',
                text: 'NEW'
              }
            },
            {
              name: 'Flags',
              url: '/coreui/coreui/icons/flags',
              icon: 'icon-star'
            },
            {
              name: 'Font Awesome',
              url: '/coreui/coreui/icons/font-awesome',
              icon: 'icon-star',
              badge: {
                variant: 'secondary',
                text: '4.7'
              }
            },
            {
              name: 'Simple Line Icons',
              url: '/coreui/coreui/icons/simple-line-icons',
              icon: 'icon-star'
            }
          ]
        },
        {
          name: 'Notifications',
          url: '/coreui/coreui/notifications',
          icon: 'icon-bell',
          children: [
            {
              name: 'Alerts',
              url: '/coreui/coreui/notifications/alerts',
              icon: 'icon-bell'
            },
            {
              name: 'Badges',
              url: '/coreui/coreui/notifications/badges',
              icon: 'icon-bell'
            },
            {
              name: 'Modals',
              url: '/coreui/coreui/notifications/modals',
              icon: 'icon-bell'
            },
            {
              name: 'Toastr',
              url: '/coreui/coreui/notifications/toastr',
              icon: 'icon-bell',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            }
          ]
        },
        {
          name: 'Plugins',
          url: '/coreui/coreui/plugins',
          icon: 'icon-energy',
          children: [
            {
              name: 'Draggable',
              url: '/coreui/coreui/plugins/draggable',
              icon: 'icon-cursor-move',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            },
            {
              name: 'Calendar',
              url: '/coreui/coreui/plugins/calendar',
              icon: 'icon-calendar',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            },
            {
              name: 'Spinners',
              url: '/coreui/coreui/plugins/spinners',
              icon: 'fa fa-spinner',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            },
          ]
        },
        {
          name: 'Tables',
          url: '/coreui/coreui/tables',
          icon: 'icon-list',
          children: [
            {
              name: 'Data Table',
              url: '/coreui/coreui/tables/data-table',
              icon: 'icon-list',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            },
            {
              name: 'Tables',
              url: '/coreui/coreui/tables/tables',
              icon: 'icon-list'
            }
          ]
        },
        {
          title: true,
          name: 'Extras',
          children: [
            {
              name: 'Charts',
              url: '/coreui/coreui/charts',
              icon: 'icon-pie-chart',
            },
            {
              name: 'Google Maps',
              url: '/coreui/coreui/google-maps',
              icon: 'icon-map',
              badge: {
                variant: 'danger',
                text: 'PRO'
              }
            },
            {
              name: 'Widgets',
              url: '/coreui/coreui/widgets',
              icon: 'icon-calculator',
              badge: {
                variant: 'primary',
                text: 'NEW'
              },
            },
          ]
        },
        {
          name: 'Pages',
          url: '/coreui/coreui/pages',
          icon: 'icon-star',
          children: [
            {
              name: 'Login',
              url: '/coreui/coreui/pages/login-coreui',
              icon: 'icon-star'
            },
            {
              name: 'Register',
              url: '/coreui/coreui/pages/register',
              icon: 'icon-star'
            },
            {
              name: 'Users',
              url: '/coreui/coreui/users',
              icon: 'icon-people'
            },
            {
              name: 'Error 404',
              url: '/coreui/coreui/pages/404',
              icon: 'icon-star'
            },
            {
              name: 'Error 500',
              url: '/coreui/coreui/pages/500',
              icon: 'icon-star'
            }
          ]
        },
        {
          name: 'Apps',
          url: '/coreui/coreui/apps',
          icon: 'icon-layers',
          children: [
            {
              name: 'Invoicing',
              url: '/coreui/coreui/apps/invoicing',
              icon: 'icon-speech',
              children: [
                {
                  name: 'Invoice',
                  url: '/coreui/coreui/apps/invoicing/invoice',
                  icon: 'icon-speech',
                  badge: {
                    variant: 'danger',
                    text: 'PRO'
                  }
                }
              ]
            },
            {
              name: 'Email',
              url: '/coreui/coreui/apps/email',
              icon: 'icon-speech',
              children: [
                {
                  name: 'Inbox',
                  url: '/coreui/coreui/apps/email/inbox',
                  icon: 'icon-speech',
                  badge: {
                    variant: 'danger',
                    text: 'PRO'
                  }
                },
                {
                  name: 'Message',
                  url: '/coreui/coreui/apps/email/message',
                  icon: 'icon-speech',
                  badge: {
                    variant: 'danger',
                    text: 'PRO'
                  }
                },
                {
                  name: 'Compose',
                  url: '/coreui/coreui/apps/email/compose',
                  icon: 'icon-speech',
                  badge: {
                    variant: 'danger',
                    text: 'PRO'
                  }
                }
              ]
            }
          ]
        },
        // {
        //   divider: true,
        //   class: 'm-2',
        // },
        // {
        //   title: true,
        //   name: 'Labels',
        // },
        // {
        //   name: 'Label danger',
        //   url: '',
        //   icon: 'fa fa-circle',
        //   label: {
        //     variant: 'danger'
        //   },
        // },
        // {
        //   name: 'Label info',
        //   url: '',
        //   icon: 'fa fa-circle',
        //   label: {
        //     variant: 'info'
        //   },
        // },
        // {
        //   name: 'Label warning',
        //   url: '',
        //   icon: 'fa fa-circle',
        //   label: {
        //     variant: 'warning'
        //   },
        // }
      ]
    }
  }
}
</script>

<style>
.coreui-link a {
    padding: 5px 20px;
    font-size: 0.8rem;
}
</style>
